import React, { useMemo, useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import { getPatient, deletePatient, getPatientsByClinicId } from "../../service/api"
// import { toast } from "react-toastify";
import DeleteConfirmationModal from "./DeleteConfirmationModal"
import Preloader from "components/Preloader/Preloader";
import { jwtDecode } from "jwt-decode";


function ViewPatient() {
  const [alluserlist, setallusers] = useState({ users: [] })
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedDeleteData, setSelectedDeleteData] = useState(null)
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    getPatientAll()
  }, [])

  const navigate = useNavigate()

  const getPatientAll = async () => {
    try {
      // Decode token to check if clinic user (is_admin: 0) or admin (is_admin: 1)
      const token = localStorage.getItem("token");
      const decoded = token ? jwtDecode(token) : null;
      const clinicID = decoded?.clinicID || null;

      let patients = [];

      if (clinicID) {
        // Clinic user — fetch only this clinic's patients
        const response = await getPatientsByClinicId(clinicID);
        patients = response?.data?.data || [];
      } else {
        // Admin — fetch all patients
        const response = await getPatient();
        patients = response?.data || [];
      }

      const reversedPatients = [...patients].reverse();

      setallusers({ users: reversedPatients });
    } catch (error) {
      console.log("Error while fetching data:", error)
    } finally {
      setLoading(false);
    }
  }

  const openViewModel = id => {
    navigate(`/patientDetails/${id}`)
  }

  const openDeleteModal = id => {
    setSelectedDeleteData(id)

    setIsDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setSelectedDeleteData(null)
    setIsDeleteModalOpen(false)
  }

  const handleDelete = async () => {
    try {
      if (selectedDeleteData) {
        let response = await deletePatient(selectedDeleteData)
        if (response.status === 200) {
          console.log("Deleted successfully", response)

          closeDeleteModal()
          getPatientAll()
        } else {
          console.log("Error deleting patient")
        }
      }
    } catch (error) {
      console.error("Error while deleting patient:", error)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        Cell: ({ row }) => row.index + 1,
        width: 50
      },
      {
        Header: "Practice",
        accessor: "clinicname.name",
      },
      {
        Header: "MPI No",
        accessor: "mpino",
      },
      {
        Header: "First Name",
        accessor: "firstname",
      },

      {
        Header: "Last Name",
        accessor: "lastname",
      },
      {
        Header: "Phone",
        accessor: "mobile",
      },
      {
        Header: "age",
        accessor: "age",
      },
      {
        Header: "Reg Date/Time",
        accessor: (row) => row.add_date + " " + row.add_time
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          const id = row.original._id
          return (
            <div className="d-flex gap-1">
              <button
                className="btn btn-warning btn-sm" title="View"
                onClick={() => openViewModel(id)}
              >
                <i className="mdi mdi-eye"></i>
              </button>

              <Link
                to={`/update-patient/${id}`}
                className="btn btn-info btn-sm"
                title="Edit"
              >
                <i className="mdi mdi-pencil"></i>
              </Link>

              <button
                className="btn btn-danger btn-sm"
                title="Delete"
                onClick={() => openDeleteModal(id)}
              >
                <i className="mdi mdi-trash-can"></i>
              </button>

              <Link
                to={`/Addvisit/${id}`}
                className="btn btn-success btn-sm"
                title="Add visit"
              >
                <i className="mdi mdi-plus"></i>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  document.title = "Patient | List"

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="page-title">Patient List</h3>
            <Link to="/Addpatient" className="btn btn-primary">
              ADD NEW PATIENT
            </Link>
          </div>
          <div>
            <TableContainer
              columns={columns}
              data={alluserlist.users}
              isGlobalFilter={true}
              isAddOptions={false}
              customPageSize={10}
              className="custom-header-css"

            />
            {loading && <Preloader />}
          </div>
          <DeleteConfirmationModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={handleDelete}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewPatient

